import { useState, useContext } from 'react';
import classNames from 'classnames';
import stringOrComponent from 'core/utils/string-or-component';

import SessionContext from 'SessionContext'

const TreeItem = (props) => {
  const context = useContext(SessionContext);
  const [state, setState] = useState({
    open: props.selectedNodePath.indexOf(props.nodePath) === 0,
    companyId: context.appState.activeCompany.id
  });

  function onClick(node, nodeContainsFolders, ev) {
    if (nodeContainsFolders) {
      setState(prev => ({...prev, open: !prev.open}));
    } else {
      props.onSelectNode(props.nodePath);
      context.crossfilterStore.runCountRefresh();
    }
  }

    const chartsStore = context.chartsStore
    const tax = chartsStore.taxonomy[1]

    const match_geos = ['cbsa', 'congress', 'county_fips', 'zip', 'state'];
    const ALL_PREFIXES = [
      window.CONSUMER_GEO_PREFIX,
      window.LIFE_EVENT_GEO_PREFIX,
      window.MOVER_GEO_PREFIX
    ].filter(Boolean); // removes "", undefined, null
    let _prefix = context.crossfilterStore.geoPrefix;

    let recentIds = JSON.parse(localStorage.getItem(`explorer:recents:${state.companyId}`)) || [];
    if(recentIds.length) {
      const updatedIds = [...new Set(
        recentIds.reduce((acc, id) => {
          let find_chart = context.chartsStore.charts[id];
          if (!find_chart) return acc; // skip undefined charts

          // strip any geo prefix to get the base geo value
          const baseId = ALL_PREFIXES.reduce((a, pfx) =>
            a.startsWith(pfx) ? a.slice(pfx.length) : a, id
          );

          // if it's a geo type, apply the current prefix
          acc.push(match_geos.includes(baseId) ? `${_prefix}${baseId}` : id);
          return acc;
        }, [])
      )];
      updatedIds.length && (tax["Recently Used"] = [updatedIds, {}]);
    }
    
    const nodeContainsFolders = props.node[1] && Object.keys(props.node[1]).length > 0;
    const nodeContainsCharts = props.node[0] && props.node[0].length > 0;
    const isOpen = state.open || props.selectedNodePath.indexOf(props.nodePath) === 0;
    const isSelected = props.selectedNodePath.join() === props.nodePath.join();
    const graphCount = props.node[0] ? props.node[0].length : 0;
    const chartRenderer = props.chartRenderer;
    const nodeIsTopLevel = Object.keys(tax).find((item) => item === props.name);

    return (
        <li key={props.name}
            className={ classNames( nodeContainsFolders || nodeIsTopLevel? 'dir' : 'list',
                        { 'is-open' : isOpen,
                          'is-selected': isSelected,
                          'is-top-level': nodeIsTopLevel})}>
          <span onClick={(ev) => onClick(props.node, nodeContainsFolders, ev)}
                title={props.name}>
          <label>{props.name} {nodeContainsFolders &&
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className={classNames("bi bi-caret-right-fill", {'is-open' : isOpen})} viewBox="0 0 16 16">
                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
            </svg>}
          </label>
            {graphCount > 0 &&
              <span className='count'>{graphCount}</span>
            }
          </span>
          { nodeContainsCharts && chartRenderer &&
              <ul className='charts'>
                { props.node[0].map( (chart_id, i)=> {
                    const ChartRenderer = stringOrComponent(chartRenderer, {chart: chartsStore.charts[chart_id]});
                    return <li key={chart_id}>{ChartRenderer}</li>;
                  }
                )}
              </ul>
          }
          { nodeContainsFolders && isOpen &&
          <NestedChartsTree
                taxonomy={props.node[1]}
                nodePath={props.nodePath}
                onSelectNode={props.onSelectNode}
                selectedNodePath={props.selectedNodePath}
                chartRenderer={props.chartRenderer} /> }
      </li>
    );
}

const NestedChartsTree = (props) => {
  const folders = props.taxonomy || {};
  const nodePath = props.nodePath || '';

  return <ul>
    { Object.entries(folders).map( ([name, node])=>
          <TreeItem
            key={name}
            node={node}
            name={name}
            nodePath={nodePath ? nodePath.concat([name]) : [name]}
            onSelectNode={props.onSelectNode}
            selectedNodePath={props.selectedNodePath}
            chartRenderer={props.chartRenderer} />
    )}
  </ul>
}

const ChartsTree = (props) => {
  return (
    <div className='charts-tree'>
      <NestedChartsTree {...props} />
    </div>
  );
}

export default ChartsTree;
